import { useEffect } from 'react';

import Format from '@/entities/sites/ui/Format';
import formats from '@/shared/lib/constants/formats';
import { FilterState } from '@/shared/lib/filter/model/types';
import { PlayerFormat } from '@/shared/types';
import { Select } from '@/shared/ui/select';

export interface IFormatSelect {
  isSelectAll?: boolean;
  value: FilterState['formats'];
  onChange: (value: FilterState['formats']) => void;
  className?: string;
  disabled?: boolean;
}

export default function FormatSelect({
  isSelectAll,
  value: currentValue = [],
  onChange,
  className = '',
  disabled = false,
}: IFormatSelect) {
  const convertedCurrent = formats.filter(({ value }) =>
    currentValue.map((id) => +id).includes(value)
  );

  useEffect(() => {
    if (isSelectAll) {
      onChange(formats.map(({ value }) => value));
    }
  }, [isSelectAll, onChange]);

  return (
    <div className={`min-w-[200px] ${className}`}>
      <Select
        type="multi"
        multiplyLabel="Formats"
        options={formats.map(({ value, label }) => ({
          value,
          label,
          labelCaption: <Format formatId={value} />,
        }))}
        current={convertedCurrent}
        onChange={(data) => {
          onChange(data.map(({ value }) => value) as PlayerFormat[]);
        }}
        disabled={disabled}
      />
    </div>
  );
}
